<template>
  <div>
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
// import VueToast from 'vue-toast-notification';
import Socket from "./socket"
export default {
  name: 'App',
  components: {
    // VueToast
  },
  data() {
    return {
      messages: []
    };
  },

  methods:{
     handleMessage(msg){
			//  this.messages.push(msg) 
       
  if(msg != `"Client left server"`){
    var pesan = JSON.parse(msg)
    this.$toast(`${pesan.value}`, {
        position: "top-right",
        timeout: 25000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
  }
            
		 }
		},
		created(){
     
			Socket.$on("message", this.handleMessage)
		},
		beforeDestroy(){
			Socket.$off("message", this.handleMessage)
		}
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */



.Vue-Toastification__close-button {
    width: 50px !important;
    font-size: 40px;
}

.Vue-Toastification__toast-body {
    line-height: 24px;
    font-size: 20px;
}

.Vue-Toastification__icon {
    width: 25px;
    height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue